import validation from 'sb-validate-js/validate.js';
import { translation } from 'utilsHelper.js';
import {substractYears} from 'datesHelper.js'
import {isPeselAdult, isPeselValid} from 'validateHelper.js';
import _range from 'lodash/range';
import _repeat from 'lodash/repeat';
import _reduce from 'lodash/reduce';
import _size from 'lodash/size';

validation.validators.isValidDate = function (value, {message}, key, global) {
    let day, month, year;
    if (typeof value == 'string') {
        const dateParts = value.split('-').map(Number);
        day = dateParts[2];
        month = (dateParts[1] > 0 ? dateParts[1] - 1 : 0);
        year = dateParts[0];
        const date = new Date(year, month, day);
        value = date;
    } else {
        let {dayOfBirth, monthOfBirth, yearOfBirth} = global;
        day = (+dayOfBirth);
        month = (+monthOfBirth);
        year = (+yearOfBirth);
    }

    const isValid = (value instanceof Date) && ((value.getFullYear() == year) && (value.getMonth() == month) && (value.getDate() == day));
    return !isValid ? message() : null;
};

validation.validators.isAdult = function (value, {message, latest}) {
    if (typeof value == 'string') {
        const dateParts = value.split('-').map(Number);
        const date = new Date(dateParts[0], (dateParts[1] > 0 ? dateParts[1] - 1 : 0), dateParts[2]);
        value = date;
    }
    const adult = value <= latest;
    return !adult ? message() : null;
};

validation.validators.checkPostalCodePattern = function (value, options, key, global) {
    const {message} = options;
    if(value && String(value).replace(/\s/g, '').length){
      return !/^[a-zA-Z0-9\-\s\/]{2,8}$/.test(value) ? message() : null;  
    }
    return null;
};

validation.validators.isPeselAdult = function (value, {message}) {
    const size = value && _size(value);
    if (size == 11) {
        const adult = isPeselAdult(value);
        return !adult ? message() : null;
    }
    return null;
};

validation.validators.isPeselValid = function (value, {message}) {
    const size = value && _size(value);
    if (size == 11) {
        const valid = isPeselValid(value);
        return !valid ? message() : null;
    }
    return null;
};

let prohibitedPhoneNumbers = _reduce(_range(1, 10), (initialArray, nextElem) => {
    const number = _repeat(nextElem, 9);
    return [...initialArray, number];
}, []);
prohibitedPhoneNumbers = [...prohibitedPhoneNumbers, ...['123456789', '987654321', '123123123']];

export default {
    REGISTER_STEP1: {
        email: {
            presence: {
                message: () => translation('account_registerForm_emailEmpty'),
            },
            email: {
                message: () => translation('account_registerForm_wrongEmailPattern'),
            },
            length: {
                minimum: 5,
                maximum: 120,
                tooShort: () => translation('account_registerForm_emailTooShort'),
                tooLong: () => translation('account_registerForm_emailTooLong'),
            }
        },
        password: {
            length: {
                minimum: 8,
                maximum: 25,
                tooShort: () => translation('account_registerForm_passwordTooShort'),
                tooLong: () => translation('account_registerForm_passwordTooLong'),
            },
            format: {
                pattern: /^(?=[^\s]*?[A-Z])(?=[^\s]*?[a-z])(?=[^\s]*?[0-9])[^\s]*$/,
                message: () => translation('account_registerForm_wrongPasswordPattern'),
            },
            presence: {
                message: () => translation('account_registerForm_passwordEmpty'),
            },
        },

        mobile: {
            presence: {
                message: () => translation('account_registerForm_phoneEmpty'),
            },
            format: {
                pattern: /^[1-9][0-9]{8}$/,
                message: () => translation('account_registerForm_wrongPhoneNumberPattern'),
            },
            length: {
                minimum: 9,
                maximum: 9,
                tooShort: () => translation('account_registerForm_phoneTooShort'),
                tooLong: () => translation('account_registerForm_phoneTooLong'),
            },
            exclusion: {
                within: prohibitedPhoneNumbers,
                message: () => translation('account_registerForm_prohibitedPhoneNumber'),
            },
            numericality: {
                onlyInteger: true,
                notInteger: () => translation('account_registerForm_onlyInteger'),
            }
        },

        rodoClause: {
            inclusion: {
                within: [true],
                message: () => translation('account_registerForm_adult'),
            },
            presence: {
                message: () => translation('account_registerForm_adult'),
            },
        }
    },
    REGISTER_STEP2: {
        firstName: {
            presence: {
                message: () => translation('account_registerForm_firstNameEmpty'),
            },
            length: {
                minimum: 3,
                tooShort: () => translation('account_registerForm_firstNameTooShort'),
            },
            format: {
                pattern: /^.*[^ ].*[a-zA-ZąĄęĘóÓćĆłŁńŃśŚżŻźŹ-\s]*$/,
                message: () => translation('account_registerForm_firstNameEmpty'),
            }
        },
        lastName: {
            presence: {
                message: () => translation('account_registerForm_lastNameEmpty'),
            },
            length: {
                minimum: 3,
                tooShort: () => translation('account_registerForm_lastNameTooShort'),
            },
            format: {
                pattern: /^.*[^ ].*[a-zA-ZąĄęĘóÓćĆłŁńŃśŚżŻźŹ-\s]*$/,
                message: () => translation('account_registerForm_lastNameEmpty'),
            }
        },
        personalIdentifier: {
            isPeselValid:{
                message: () => translation('account_registerForm_peselNotValid')
            },
            isPeselAdult: {
                message: () => translation('account_registerForm_notAdult')
            },
            presence: {
                message: () => translation('account_registerForm_peselEmpty'),
            },
            length: {
                minimum: 11,
                maximum: 11,
                tooShort: () => translation('account_registerForm_peselTooShort'),
                tooLong: () => translation('account_registerForm_peselTooLong'),
            }
        },
        address:{
            presence: {
                message: () => translation('account_registerForm_addressEmpty'),
            },
            format: {
                pattern: /^.*[^ ].*[\D\d\s-./][^!"#$;*+<=>@~{|}`]*/,
                message: () => translation('account_registerForm_addressWrongPattern'),
            },
            length: {
                minimum: 7,
                tooShort: () => translation('account_registerForm_tooShort'),
            },
        },
        postalCode:{
            presence: {
                message: () => translation('account_registerForm_postalCodeEmpty'),
            },
            checkPostalCodePattern: {
                message: () => translation('account_registerForm_postalCodeWrongPattern'),
            },
            format: {
                pattern: /^.*[^ ].*[0-9]*$/,
                message: () => translation('account_registerForm_postalCodeEmpty'),
            }
        },

        dateOfBirth: {
            isValidDate:{
                message: () => translation('account_registerForm_dateOfBirthNotValid')
            },
            isAdult: {
                latest: substractYears(new Date, 18),
                message: () => translation('account_registerForm_notAdult')
            }
        },
        verificationCode: {
            presence: {
                message: () => translation('account_registerForm_smsCodeEmpty'),
            },
            length: {
                minimum: 4,
                maximum: 4,
                tooShort: () => translation('account_registerForm_smsCodeTooShort'),
                tooLong: () => translation('account_registerForm_smsCodeTooLong'),
            },
            numericality: {
                onlyInteger: true,
                message: () => translation('account_registerForm_verificationCodeIntegerOnly')
            }
        }
    },
    FORGOT_PASSWORD: {
        email: {
            presence: {
                message: () => translation('account_forgotPasswordForm_emailEmpty'),
            },
            email: {
                message: () => translation('account_forgotPasswordForm_wrongEmailPattern'),
            },
        }
    }
};

